import type { Feedback, FeedbackNotionList, FeedbackTag } from '~/types/feedback'

import config from '~/config'
import { request } from '~/utils/request'

export const createFeedback = ({
  message,
  rating,
  screenshotUrl,
  screenSize,
  title,
  url,
  userAgent,
}: {
  message?: string
  rating?: number
  screenSize: string
  screenshotUrl?: string
  title: string
  url: string
  userAgent: string
}): Promise<{ id: string }> => {
  return request({
    data: {
      message,
      rating,
      screenSize,
      screenshotUrl,
      title,
      url,
      userAgent,
    },
    method: 'POST',
    url: `${config.SERVICES_API}/feedbacks`,
  })
}

export const getFeedbacks = async (): Promise<Feedback[]> => {
  const response = await request<FeedbackNotionList>({
    url: `${config.SERVICES_API}/feedbacks`,
  })

  return response.results.map(({ properties }) => ({
    object: properties.Object.title[0].text.content,
    status: properties.Status.select.name,
  }))
}

export const getFeedbackTags = (): Promise<FeedbackTag[]> => {
  return request({
    url: `${config.SERVICES_API}/feedbacks/tags`,
  })
}
